import { NgModule } from '@angular/core';

import { VendorRoutingModule } from './vendor-routing.module';
import { HeaderVendorComponent } from './components/header-vendor/header-vendor.component';
import { FooterVendorComponent } from './components/footer-vendor/footer-vendor.component';
import { HomeVendorComponent } from './components/home-vendor/home-vendor.component';
import { MenuVendorComponent } from './components/menu-vendor/menu-vendor.component';
import { ContainerVendorComponent } from './components/container-vendor/container-vendor.component';
import { PageTitleVendorComponent } from './containers/page-title-vendor/page-title-vendor.component';
import { CreateProductComponent } from './components/create-product/create-product.component';
import { CreateCategoryComponent } from './components/create-category/create-category.component';
import { SharedModule } from '../shared/shared.module';
import { StoreModule } from '@ngrx/store';
import { MAT_COLOR_FORMATS, NGX_MAT_COLOR_FORMATS, NgxMatColorPickerModule } from '@angular-material-components/color-picker';


@NgModule({
  declarations: [
    HeaderVendorComponent,
    FooterVendorComponent,
    HomeVendorComponent,
    MenuVendorComponent,
    ContainerVendorComponent,
    PageTitleVendorComponent,
    CreateProductComponent,
    CreateCategoryComponent
  ],
  imports: [
    StoreModule.forRoot({}),
    SharedModule,
    VendorRoutingModule,

    NgxMatColorPickerModule
  ],
  exports: [
    HeaderVendorComponent,
    FooterVendorComponent,
    MenuVendorComponent,
    PageTitleVendorComponent
  ],
  providers: [,
    { provide: MAT_COLOR_FORMATS, useValue: NGX_MAT_COLOR_FORMATS }
  ]
})
export class VendorModule { }
